import React from 'react'
import './referral-card.css'

const ReferralCard = () => {
	return (
		<div className="referral-card">
			<div className="referral-left">
				<h2>
					Invite Friends,{' '}
					<span className="highlight">Earn Together</span>
				</h2>
				<p>
					Share Agent Jeeves with your friends and earn 5% of their
					yield. No cap on referrals.
				</p>
				<div className="referral-buttons">
					<button className="share-btn">
						<span className="icon">🔗</span> Share Your Link
					</button>
					<button className="copy-btn">
						<span className="icon">📋</span> Copy Link
					</button>
				</div>
			</div>

			<div className="referral-right">
				<div className="stat-box">
					<span className="label">Total Earned</span>
					<span className="value gold">$340</span>
				</div>
				<div className="stat-box">
					<span className="label">Total Signups</span>
					<span className="value">5</span>
				</div>
			</div>
		</div>
	)
}

export default ReferralCard
